package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebAvatar

enum class AdminAvatarSize(val px: Int, val fontPx: Int) {
    SM(32, 12), MD(34, 13), LG(72, 22)
}

@Composable
fun AdminAvatar(name: String?, url: String?, size: AdminAvatarSize = AdminAvatarSize.MD) {
    WebAvatar(name = name, url = url, size = size.px, fontPx = size.fontPx)
}
